import * as React from 'react'
import { SVGProps } from 'react'

const SvgPhoneWithPurpleLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="phoneWithPurpleLine_svg__a" fill="#fff">
      <path d="M23 11a6.999 6.999 0 0 0-7.71-6.964l.176 1.73A5.261 5.261 0 0 1 21.26 11H23Z" />
    </mask>
    <path
      d="M23 11a6.999 6.999 0 0 0-7.71-6.964l.176 1.73A5.261 5.261 0 0 1 21.26 11H23Z"
      stroke="#5F41B2"
      strokeWidth={2}
      mask="url(#phoneWithPurpleLine_svg__a)"
    />
    <mask id="phoneWithPurpleLine_svg__b" fill="#fff">
      <path d="M27 10A10 10 0 0 0 15.984.052l.172 1.681A8.31 8.31 0 0 1 25.31 10H27Z" />
    </mask>
    <path
      d="M27 10A10 10 0 0 0 15.984.052l.172 1.681A8.31 8.31 0 0 1 25.31 10H27Z"
      stroke="#5F41B2"
      strokeWidth={2}
      mask="url(#phoneWithPurpleLine_svg__b)"
    />
    <path
      d="m9.503 7.257-.929.372.929-.372Zm1.054 2.636.929-.372-.929.372Zm-.32 2.023.768.64-.768-.64Zm-.568.68.768.641-.768-.64Zm.122 2.695L9.084 16l.707-.708Zm1.918 1.918.707-.708-.707.707Zm2.694.122-.64-.768.64.768Zm.681-.568.64.769-.64-.769Zm2.023-.32-.371.928.371-.928Zm2.636 1.054.371-.928-.371.928ZM4.895 7h2.75V5h-2.75v2Zm3.68.629 1.054 2.635 1.857-.743-1.055-2.635-1.857.743Zm.893 3.647-.567.68 1.537 1.281.567-.68-1.537-1.281Zm-.384 4.723 1.917 1.917 1.415-1.415-1.917-1.917L9.084 16Zm5.96 2.1.68-.567-1.28-1.537-.681.568 1.28 1.536Zm1.692-.728 2.635 1.055.743-1.857-2.636-1.055-.742 1.857ZM20 19.354v2.751h2v-2.75h-2ZM19.105 23C10.763 23 4 16.237 4 7.895H2C2 17.342 9.658 25 19.105 25v-2Zm.895-.895c0 .494-.4.895-.895.895v2A2.895 2.895 0 0 0 22 22.105h-2Zm-.629-3.68a1 1 0 0 1 .629.93h2a3 3 0 0 0-1.886-2.786l-.743 1.857Zm-3.647-.893a1 1 0 0 1 1.012-.16l.742-1.858a3 3 0 0 0-3.034.481l1.28 1.537Zm-4.723.384a3 3 0 0 0 4.042.183l-1.28-1.537a1 1 0 0 1-1.347-.06L11 17.915Zm-2.1-5.96A3 3 0 0 0 9.084 16l1.415-1.415a1 1 0 0 1-.062-1.347l-1.536-1.28Zm.728-1.692a1 1 0 0 1-.16 1.012l1.536 1.28a3 3 0 0 0 .48-3.035l-1.856.743ZM7.646 7a1 1 0 0 1 .928.629l1.857-.743A3 3 0 0 0 7.646 5v2ZM4.895 5A2.895 2.895 0 0 0 2 7.895h2C4 7.4 4.4 7 4.895 7V5Z"
      fill="#5F41B2"
    />
  </svg>
)

export default SvgPhoneWithPurpleLine
